/**
 * Different link designs.
 * @public
 */
enum LinkDesign {
	/**
	 * default type (no special styling)
	 * @public
	 */
	Default = "Default",

	/**
	 * subtle type (appears as regular text, rather than a link)
	 * @public
	 */
	Subtle = "Subtle",

	/**
	 * emphasized type
	 * @public
	 */
	Emphasized = "Emphasized",
}

export default LinkDesign;
